import {
    createSelector,
} from '@reduxjs/toolkit';

import {
    selectUserSelectionIds,
    selectCountUserSelections,
} from './userSelectionsSelectors';

import {
    selectBetReceiptExists,
    selectBetReceiptIds,
    selectCountReceiptSelections,
} from './betReceiptSelectors';

import {
    selectRecommendationGlobalEnabled,
    selectRecommendationBetPlacementEnabled,
    selectRecommendationBetReceiptEnabled,
} from '~SpectateStore/selectors/clientStateSelectors';

export const selectRecommendations = state => state.betslip.recommendations;

export const selectShouldQueryRecommendations = createSelector(
    [
        selectCountUserSelections,
        selectCountReceiptSelections,
        selectRecommendationGlobalEnabled,
        selectRecommendationBetPlacementEnabled,
        selectRecommendationBetReceiptEnabled,
    ],
    (
        betslipCount,
        receiptCount,
        isRecommendationGlobalEnabled,
        isRecommendationBetPlacementEnabled,
        isRecommendationBetReceiptEnabled
    ) => {
        if (!isRecommendationGlobalEnabled) {
            return false;
        }

        const shouldGetBetslipRecommendations = isRecommendationBetPlacementEnabled && betslipCount > 0 && receiptCount < 1;
        const shouldGetBetReceiptRecommendations = isRecommendationBetReceiptEnabled && receiptCount > 0;

        return shouldGetBetslipRecommendations || shouldGetBetReceiptRecommendations;
    }
);

export const selectRecommendationsSelectionsIds = createSelector(
    [
        selectBetReceiptExists,
        selectUserSelectionIds,
        selectBetReceiptIds,
    ],
    (isBetReceipt, betslipSelections, betReceiptSelections) => {
        const data = isBetReceipt ? betReceiptSelections : betslipSelections;

        /**
         * Forecast and tricast selections ids comes in as single selection id
         * concatenated with `_`.
         * In order to get recommendations for them we must split the "single" selection id
         * into mupltiple ones so we pass to BE "1,2,3" instead of "1_2_3"
         */
        const output = data.reduce((acc, current) => ([
            ...acc,
            ...(current.split('_')),
        ]), []);

        return output;
    }
);
